module.exports = __webpack_public_path__ + "static/img/img-rate-50@3x.bc0f7c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/img-rate-50@3x.png
// module id = 5j/A
// module chunks = 18